import type { DesignModuleSpecJson } from '../data/contracts';

/** Une recompilation conserve l'espace de clés des textes déjà revus, sans ajouter de propriété au Module Spec. */
export function nativeTemplatePrefix(spec: DesignModuleSpecJson): string {
  const messages = (spec.presentation as { templateMessages?: Record<string, unknown> } | undefined)?.templateMessages ?? {};
  const prefixes = new Set(Object.keys(messages).flatMap(key => /^([a-z][a-z0-9]*)\.tpl\./.exec(key)?.[1] ?? []));
  return prefixes.size === 1 ? [...prefixes][0] : String(spec.module.domain ?? spec.module.code ?? '').replace(/-/g, '');
}
